import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

import { Subscription } from 'rxjs/Subscription';

import { Restaurant } from './restaurant';

import { RestaurantService } from './restaurant.service';

import { MessageService }     from './message.service';

import 'rxjs/add/operator/switchMap';

@Component({
	selector: 'book-now',
	template:'<div> <navigation></navigation><restaurant-book></restaurant-book><contact-us></contact-us><timetable-location></timetable-location><footer></footer></div>',
	
})
export class BooknowComponent  {

 deviceInfo = null;
        device = "unknown";
	constructor(
		
   
  	) {}


}




// WEBPACK FOOTER //
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/book-now.component.ts